<script setup lang="ts">
import FormDataBloqueada from '../components/form-databloqueada.vue'
import { useDataBloqueadaStore } from '../store/useDataBloqueadaStore'

definePage({
  meta: {
    navActiveLink: 'admin-data-bloqueada',
    action: 'create',
    subject: 'data-bloqueada',
  },
})

const { resetForm } = useDataBloqueadaStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormDataBloqueada />
</template>
